import React from 'react';
import { LocationPage } from './useLocationPage';
import './useLocationPage.css';

// ─── Images ───────────────────────────────────────────────────────────────────
// Swap out any of these for Sarasota-specific shots
import heroImg   from '../images/tampa3.webp';
import bgImg     from '../images/image8.webp';
import slideImg1 from '../images/image121.webp';
import slideImg2 from '../images/image117.webp';
import slideImg3 from '../images/image50.webp';

// ─── Config ───────────────────────────────────────────────────────────────────
const sunsetParkConfig = {

  /* ── SEO ────────────────────────────────────────────────────────────────── */
  pageTitle:       'Sunset Park Tree Service | Sam\'s Tree Service',
  metaDescription: 'Expert tree trimming and removal in Sunset Park, FL. Sam\'s Tree Service handles dangerous trees safely and professionally.',
  canonicalUrl:    'https://samstreeservice.com/tree_service_sunset_park',

  /* ── Hero ───────────────────────────────────────────────────────────────── */
  heroHeading: 'Serving Sunset Park',
  heroImageUrl: heroImg,
  bgImageUrl:   bgImg,

  /* ── Slide images ───────────────────────────────────────────────────────── */
  slideImage1: slideImg1,
  slideImage2: slideImg2,
  slideImage3: slideImg3,

  /* ── Main text panel ────────────────────────────────────────────────────── */
  sectionHeading: 'Professional Tree Service in Sunset Park Specializing In Dangerous Trees',

  paragraphs: [
    `At <strong>Sam's Tree Service</strong>, we serve the upscale waterfront and 
     residential properties of <strong>Sunset Park</strong> with the professional 
     tree care that this premier South Tampa neighborhood deserves. Situated along 
     Old Tampa Bay, properties here face constant wind and tidal exposure and 
     the mature trees that make Sunset Park beautiful are also the ones most 
     at risk of becoming storm hazards. Our team handles that risk precisely 
     and professionally.`,

    `We specialize in <strong>high care tree removal and trimming on premium 
     waterfront and residential properties</strong> overhanging limbs near 
     luxury homes and pool areas, storm compromised trees near seawalls and 
     docks, canopy reductions that preserve your water views while eliminating 
     storm risk, and careful full removals that protect your investment 
     throughout the process.`,

    `<strong>Sam's Tree Service</strong> delivers expert, trusted tree care 
     throughout <strong>Sunset Park</strong> and the surrounding 
     <strong>South Tampa Bay</strong> waterfront communities protecting 
     the value and beauty of your property all year long.`,
  ],
  ctaLabel: 'Get a Free Estimate!',

  /* ── Service buttons (optional — defaults to the 4 standard ones) ────────── */
  // serviceButtons: [
  //   { label: 'Tree Trimming', to: '/tree_trimming' },
  //   { label: 'Tree Removal',  to: '/tree_removal'  },
  //   { label: 'Stump Removal', to: '/stump_removal'  },
  //   { label: 'Debris Hauling',to: '/debris_hauling' },
  // ],

  /* ── Google Map ─────────────────────────────────────────────────────────── */
  mapCity: 'Sunset Park, FL',
};

// ─── Page ─────────────────────────────────────────────────────────────────────
const Services_SunsetPark = () => <LocationPage config={sunsetParkConfig} />;
export default Services_SunsetPark;
